// Mock data for PDX Window Tint website

export const businessInfo = {
  name: "PDX Window Tint",
  phone: "503-328-4130",
  email: "pdxwindowtint@gmail.com",
  location: "Portland Metro Area",
  areas: ["PDX", "Hillsboro", "Beaverton"],
  depositAmount: 50,
  paymentMethod: "Zelle",
  dropOffOnly: true,
  hours: {
    weekday: "Monday - Friday: 4:00 PM - 7:00 PM",
    weekend: "Saturday - Sunday: 11:00 AM - 7:00 PM"
  },
  social: {
    instagram: "@pdxwindowtint",
    followers: "2,338"
  }
};

export const services = [
  {
    id: 1,
    title: "Window Tinting",
    description: "Professional automotive window tinting with premium film. Enhanced privacy, UV protection, and heat reduction for your vehicle.",
    icon: "Gauge",
    image: "https://images.unsplash.com/photo-1567808291548-fc3ee04dbcf0",
    features: ["UV Protection", "Heat Reduction", "Privacy Enhancement", "Lifetime Warranty"]
  },
  {
    id: 3,
    title: "Ambient Lighting",
    description: "Custom interior ambient lighting installation. Create the perfect atmosphere with adjustable LED lighting systems.",
    icon: "Lightbulb",
    image: "https://images.unsplash.com/photo-1615135902020-f499dc74b655",
    features: ["RGB Color Options", "App Control", "Multiple Zones"]
  },
  {
    id: 4,
    title: "Starlight Headliner",
    description: "Luxury starlight headliner installation. Transform your vehicle's ceiling into a stunning night sky effect.",
    icon: "Sparkles",
    image: "https://static.prod-images.emergentagent.com/jobs/3f11ed59-e4bc-415d-8111-94c498404b20/images/c776439fd9663704ecf497942d279b0c457090015958749f09232e735770134b.png",
    features: ["Fiber Optic Stars", "Custom Patterns", "Adjustable Brightness", "Premium Look"]
  },
  {
    id: 2,
    title: "Vinyl Wrap",
    description: "Complete or partial vehicle wraps with high-quality vinyl. Transform your car's appearance with custom colors and finishes.",
    icon: "Palette",
    image: "https://images.unsplash.com/photo-1760550517469-24a705aec2d2",
    features: ["Custom Colors", "Paint Protection", "Removable", "Premium Materials"]
  },
  {
    id: 5,
    title: "Remove Tint",
    description: "Professional window tint removal service. Clean removal without damage to glass or defroster lines.",
    icon: "Eraser",
    image: "https://images.unsplash.com/photo-1567808291548-fc3ee04dbcf0",
    features: ["Safe Removal", "No Glass Damage", "Defroster Safe", "Clean Finish"]
  },
  {
    id: 6,
    title: "Chrome Delete",
    description: "Professional chrome trim blackout service. Transform your vehicle with a sleek, modern blacked-out look.",
    icon: "Paintbrush",
    image: "/images/chrome-delete.jpeg",
    features: ["Window Trim", "Door Handles", "Emblems", "Custom Work"]
  }
];

export const galleryImages = [
  {
    id: 1,
    url: "https://i.ibb.co/ZzgHDP5f/IMG-3403.jpg",
    title: "Professional Window Tinting",
    category: "Window Tint"
  },
  {
    id: 2,
    url: "https://i.ibb.co/84SGnVKf/IMG-3446.jpg",
    title: "Custom Installation",
    category: "Window Tint"
  },
  {
    id: 3,
    url: "https://i.ibb.co/xS1Ls3F0/IMG-3498.jpg",
    title: "Quality Workmanship",
    category: "Window Tint"
  },
  {
    id: 4,
    url: "https://i.ibb.co/d0CjQrhz/IMG-3499.jpg",
    title: "Expert Detailing",
    category: "Custom Work"
  },
  {
    id: 5,
    url: "https://i.ibb.co/zWHyCRtk/IMG-3500.jpg",
    title: "Premium Service",
    category: "Window Tint"
  },
  {
    id: 6,
    url: "https://i.ibb.co/V0kpsMzC/IMG-3501.jpg",
    title: "Professional Results",
    category: "Custom Work"
  },
  {
    id: 7,
    url: "https://i.ibb.co/gFj5M0R1/IMG-3503.jpg",
    title: "Starlight Installation",
    category: "Custom Work"
  },
  {
    id: 8,
    url: "https://i.ibb.co/QvS3LTWg/IMG-3508.jpg",
    title: "Finished Project",
    category: "Window Tint"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Marcus Johnson",
    rating: 5,
    text: "Best window tint job I've ever had! Professional service and the tint looks amazing. Drop-off was super convenient.",
    service: "Window Tinting"
  },
  {
    id: 2,
    name: "Sarah Mitchell",
    rating: 5,
    text: "The vinyl wrap on my car is incredible! So many compliments. The team was professional and the quality is top-notch.",
    service: "Vinyl Wrap"
  },
  {
    id: 3,
    name: "David Chen",
    rating: 5,
    text: "Ambient lighting installation exceeded my expectations. The customization options are endless and it looks factory-quality.",
    service: "Ambient Lighting"
  }
];

export const pricing = [
  {
    id: 1,
    title: "Front Windshield Only",
    price: 100,
    description: "Windshield tinting service",
    features: [
      "Front windshield",
      "UV protection",
      "Heat reduction",
      "Lifetime warranty"
    ],
    popular: false
  },
  {
    id: 2,
    title: "Front Two Windows",
    price: 100,
    description: "Match rear factory tint",
    features: [
      "Driver & Passenger windows",
      "Match factory rear tint",
      "Premium film",
      "Lifetime warranty"
    ],
    popular: false
  },
  {
    id: 3,
    title: "Sedan & Coupe",
    price: 200,
    description: "Complete window tinting for sedans and coupes",
    features: [
      "All side windows",
      "Rear window",
      "Premium Quality Film",
      "Lifetime warranty",
    ],
    popular: false
  },
  {
    id: 4,
    title: "Trucks & SUV",
    price: 300,
    description: "Full tinting service for larger vehicles",
    features: [
      "All side windows",
      "Rear window",
      "Premium Quality Film",
      "Lifetime warranty",
    ],
    popular: false
  },
  {
    id: 5,
    title: "Ambient Lighting",
    price: 400,
    description: "Custom interior LED lighting installation",
    features: [
      "RGB color options",
      "App control system",
      "Multiple zones",
      "Premium LED strips",
    ],
    popular: false
  },
  {
    id: 6,
    title: "Starlight Headliner",
    price: 800,
    description: "Luxury fiber optic starlight ceiling",
    features: [
      "Fiber optic stars",
      "Custom star patterns",
      "Adjustable brightness",
      "Premium materials",
    ],
    popular: false
  },
  {
    id: 7,
    title: "Remove Tint",
    price: 100,
    description: "Professional window tint removal",
    features: [
      "Safe removal",
      "No glass damage",
      "Defroster safe",
      "Clean finish",
    ],
    popular: false
  }
];

export const mockBookings = [];

export const addMockBooking = (booking) => {
  const newBooking = {
    id: Date.now(),
    ...booking,
    status: "pending",
    createdAt: new Date().toISOString()
  };
  mockBookings.push(newBooking);
  return newBooking;
};
